import React from 'react';
import * as S from './MainSider/MainSider.styles';
import { RightOutlined } from '@ant-design/icons';
import { useResponsive } from 'hooks/useResponsive';
import { useAppSetting } from '@app/contexts/AppSettingContext';
import logoUrl from '@app/assets/images/logo.png';
import './SiderLogo.css';
interface SiderLogoProps {
  isSiderCollapsed: boolean;
  toggleSider: () => void;
}

export const SiderLogo: React.FC<SiderLogoProps> = ({ isSiderCollapsed, toggleSider }) => {
  const { isTablet } = useResponsive();
  const { appName } = useAppSetting();

  return (
    <S.SiderLogoDiv>
      <S.SiderLogoLink to="/" $collapsed={isSiderCollapsed}>
        <img src={logoUrl} alt={appName} width={55} height={30} className="sider-logo__img" />
        {!isSiderCollapsed && <S.BrandSpan>{appName}</S.BrandSpan>}
      </S.SiderLogoLink>
      {isTablet && (
        <S.CollapseButton
          shape="circle"
          size="small"
          $isCollapsed={isSiderCollapsed}
          icon={<RightOutlined rotate={isSiderCollapsed ? 0 : 180} />}
          onClick={toggleSider}
        />
      )}
    </S.SiderLogoDiv>
  );
};
